import React from 'react'
import PropTypes from 'prop-types'
import {ErrorMessage} from './ErrorMessage'
import { saveLead } from '../../api'
import FBLogin from '../../components/FBLogin'
import EmailInput from '../../components/EmailInput'

export default class Form extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			email: '',
			emailValid: false,
			facebookButtonEnabled: false,
			errorMessage: null,
			emailSubmitted: false,
			emailFocused: (props.emailFocused === true || props.emailFocused === false) ? props.emailFocused : true
		}
		this.validEmailEntered = this.validEmailEntered.bind(this)
		this.invalidEmailEntered = this.invalidEmailEntered.bind(this)
		this.facebookButtonClicked = this.facebookButtonClicked.bind(this)
	}

	validEmailEntered(email) {
		this.setState({email, emailValid: true, facebookButtonEnabled: true})
	}

	invalidEmailEntered(email) {
		this.setState({email, emailValid: true, facebookButtonEnabled: false})
	}

	facebookButtonClicked(e) {
		const {email} = this.state
		if(this.state.emailValid) {
			this.setState({facebookButtonEnabled: false, emailSubmitted: true, errorMessage: null})
			if(window.fbq) {
				window.fbq('track', 'Lead', {content_name: 'AdScore'})
			}
			// Save the lead and record in mixpanel
			if(window.mixpanel) {
				window.mixpanel.track('Landing Page Converted', {
					landing_page: 'AdScore',
					email
				})
			}
			saveLead(email, this.props.trafficSource, this.props.paidTrafficSource)
			return true
		} else {
			e.preventDefault()
			this.setState({errorMessage: 'Please enter a valid email.'})
		}
	}

	// TODO: Handle input focusing
	render () {
		return (
			<div className="start-form">
				<ErrorMessage message={this.state.errorMessage} />
				<EmailInput
					focus={this.state.emailFocused}
					ref={this.emailInput}
					disabled={this.state.emailSubmitted}
					validEmailEntered={this.validEmailEntered}
					invalidEmailEntered={this.invalidEmailEntered}
				/>
				<span id='terms'>
					We value your privacy. Unified may use the information you provide to us to contact you about our relevant content, products, and services. You may unsubscribe from these communications at any time. For more information about the information we collect and how it is used, check out our <a href='https://unified.com/privacy-policy' target='_blank' rel="noopener noreferrer">Privacy Policy</a>. By clicking [&quot;Get My Score&quot;] you indicate your acceptance of these terms.
				</span>
				<FBLogin
					enabled={this.state.facebookButtonEnabled}
					facebookButtonClicked={this.facebookButtonClicked}
					sessionEmail={this.state.email}
					history={this.props.history}
					facebookSessionSet={this.props.facebookSessionSet}
				/>
			</div>
		)
	}
}

Form.propTypes = {
	emailFocused: PropTypes.bool,
	history: PropTypes.object,
	facebookSessionSet: PropTypes.func,
	trafficSource: PropTypes.string,
	paidTrafficSource: PropTypes.string
}


// WEBPACK FOOTER //
// ./src/containers/Home/form.js